import { Component } from '@angular/core';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { LogoutButtonAbstract } from '../../../ui/common/logout-button.abstract';

@Component({
    selector: 'account-ui-logout-button-inline',
    templateUrl: './account-ui-logout-button-inline.component.html',
    standalone: true,
    imports: [ActionComponent, ResultComponent, TranslatePipe]
})
export class AccountUiLogoutButtonInlineComponent extends LogoutButtonAbstract {}
